import React from 'react'
import { useMsal } from '@azure/msal-react'
import { loginRequest } from '../authConfig'
import Button from '@mui/material/Button'

export const SignInButton = (props) => {
  // Boton de ingreso para login AAD

  const { instance } = useMsal()

  async function handleLogin(instance) {
    try {
      // Navigates away to Entra; the response is picked up by AuthCallback
      // on redirectUri, which does the ADLogin backend exchange.
      await instance.loginRedirect(loginRequest)
    } catch (e) {
      console.error(e)
    }
  }

  return (
    <Button
      sx={{
        backgroundColor: window.$brand === 'PRB' ? '#17afb6' : '#78BE20'
      }}
      variant='contained'
      onClick={() => handleLogin(instance)}
    >
      Ingreso de usuarios {window.$brand}
    </Button>
  )
}
